var _style, _path, _path2, _path3, _path4, _path5, _polygon, _line, _line2, _line3, _line4, _line5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicketsRedeemedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144.7 144",
    style: {
      enableBackground: "new 0 0 144.7 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.4044;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Fill-1_1_);}\n\t.st2{opacity:0.7038;fill-rule:evenodd;clip-rule:evenodd;fill:url(#Fill-5_1_);enable-background:new    ;}\n\t.st3{opacity:0.3983;fill-rule:evenodd;clip-rule:evenodd;fill:url(#Fill-9_1_);enable-background:new    ;}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;stroke:#026CDF;stroke-width:2.9;}\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;stroke:#026CDF;stroke-width:1.45;}\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st7{fill:none;stroke:#026CDF;stroke-width:1.45;stroke-linecap:round;}\n\t.st8{fill:none;stroke:#026CDF;stroke-width:0.725;stroke-linecap:round;}\n\t.st9{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;stroke:#026CDF;stroke-width:1.45;stroke-linecap:round;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(16.785993, 0.000000)",
    className: "st0"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fill-1_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -243.6247,
    y1: 466.7974,
    x2: -243.591,
    y2: 465.76,
    gradientTransform: "matrix(144.7276 0 0 -144 35312.2578 67213)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#026CDF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C56BFF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    className: "st1",
    d: "M69.9,3.9c32.2,6.7,55.5,35.3,55.5,68.1c0,38.3-31.3,69.5-69.9,69.5c-38.5,0-69.9-31.2-69.9-69.5 c0-38.3,31.3-69.5,69.9-69.5V0C15.7,0-16.8,32.3-16.8,72c0,39.7,32.5,72,72.4,72c39.9,0,72.4-32.3,72.4-72 c0-33.9-24.2-63.6-57.5-70.5L69.9,3.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fill-5_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -243.3839,
    y1: 466.4853,
    x2: -243.297,
    y2: 465.2538,
    gradientTransform: "matrix(122.314 0 0 -121.6991 29819.3223 56765.0156)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#026CDF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C56BFF"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-5",
    className: "st2",
    d: "M56.3,11.2C22.6,10.8-5.2,37.7-5.6,71.3c-0.4,33.6,26.7,61.2,60.4,61.5c4.4,0.1,8.9-0.4,13.2-1.3 l-0.5-2.4c-4.1,0.9-8.4,1.3-12.6,1.2c-32.4-0.4-58.4-26.9-58-59.1c0.4-32.2,27-58.1,59.4-57.7c32.4,0.4,58.4,26.9,58,59.1 c-0.2,14.8-5.9,28.9-16.2,39.6l1.8,1.7c10.7-11.2,16.7-25.8,16.8-41.2C117.1,39.2,90,11.5,56.3,11.2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fill-9_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -242.9485,
    y1: 465.9439,
    x2: -242.8568,
    y2: 464.4626,
    gradientTransform: "matrix(97.6486 0 0 -97.1577 23774.5059 45267.3594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#026CDF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C56BFF"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-9",
    className: "st3",
    d: "M55.6,23.4c-6.9,0-13.6,1.4-19.8,4.2l0.9,2.1c6-2.6,12.3-4,18.9-4c25.7,0,46.6,20.8,46.6,46.3 s-20.9,46.3-46.6,46.3S9,97.5,9,72c0-14.3,6.5-27.6,17.8-36.5l-1.4-1.8C13.6,43,6.8,57,6.8,72c0,26.8,21.9,48.6,48.8,48.6 c26.9,0,48.8-21.8,48.8-48.6C104.4,45.2,82.5,23.4,55.6,23.4"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1_",
    className: "st4",
    d: "M39.6,21.4l49.7-6.9c1.2-0.2,2.3,0.2,3.2,0.8c0.9,0.7,1.5,1.7,1.7,2.9l0,0L108.5,119 c0.2,1.2-0.2,2.3-0.8,3.2s-1.7,1.5-2.9,1.7l0,0l-49.7,6.9c-1.2,0.2-2.3-0.2-3.2-0.8c-0.9-0.7-1.5-1.7-1.7-2.9l0,0L35.9,26.3 c-0.2-1.2,0.2-2.3,0.8-3.2C37.5,22.2,38.5,21.5,39.6,21.4L39.6,21.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_",
    className: "st5",
    d: "M47,34.6l12-1.7c0.6,1.3,1.6,2.3,2.8,2.9c1.3,0.6,3,0.8,5.1,0.5c2.1-0.3,3.6-0.9,4.7-1.9 c1-0.9,1.7-2.1,1.9-3.5l0,0l12.3-1.7c0.6-0.1,1.2,0.1,1.6,0.4s0.8,0.8,0.8,1.4l0,0l10.9,77.3c0.1,0.6-0.1,1.2-0.4,1.6 c-0.3,0.4-0.8,0.8-1.4,0.8l0,0l-38.9,5.4c-0.6,0.1-1.2-0.1-1.6-0.4c-0.4-0.3-0.8-0.8-0.8-1.4l0,0L45.2,37c-0.1-0.6,0.1-1.2,0.4-1.6 C45.9,35,46.4,34.6,47,34.6L47,34.6z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle_3_",
    className: "st6",
    points: "50.1,100.1 101.1,93 104.7,118 53.6,125.2  "
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line-2",
    className: "st7",
    x1: 72.7,
    y1: 121.7,
    x2: 87,
    y2: 119.7
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line-2-Copy",
    className: "st8",
    x1: 51.7,
    y1: 53.9,
    x2: 86.4,
    y2: 49.2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "Line-2-Copy_1_",
    className: "st8",
    x1: 53,
    y1: 46.8,
    x2: 60.2,
    y2: 45.8
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    id: "Line-2-Copy_2_",
    className: "st8",
    x1: 63.9,
    y1: 45.3,
    x2: 71.1,
    y2: 44.3
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    id: "Line-2-Copy_3_",
    className: "st8",
    x1: 75.5,
    y1: 43.9,
    x2: 82.7,
    y2: 42.9
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4_",
    className: "st9",
    d: "M50.6,99.5l5.8-0.8c8.2,2,14.7,2.7,19.5,2c4.8-0.7,11.5-3.2,20.1-7.5l4.2-0.6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketsRedeemedIcon);
export default __webpack_public_path__ + "static/media/tickets-redeemed-icon.d4288374b07c1c1f4b663e5bf8a8665c.svg";
export { ForwardRef as ReactComponent };